const MAX_ITENS_POR_PROTOCOLO = 45;
const ERROS_PROTOCOLO_MASSA = {
  CONTRATO_PROTOCOLADO:
    'O contrato informado já pertence a um protocolo Principal, é necessário exclui-lo do protocolo para inserir.',
  CONTRATO_RECEPCIONADO:
    'Contrato já recepcionado neste tipo de protocolo. Realize um protocolo de Complemento / Regularização.',
  COMPLEMENTO_SEM_PROTOCOLO: 'Contrato não possui um protocolo. Realize um protocolo principal.',
  CONTRATO_NAO_LOCALIZADO: 'Número de contrato não localizado.',
  PROPOSTA_NAO_LOCALIZADA: 'Número de proposta não localizado.',
  MAXIMO_CONTRATOS: `Excedido a quantidade máxima de ${MAX_ITENS_POR_PROTOCOLO} contratos no protocolo.`,
  MAXIMO_PROPOSTAS: `Excedido a quantidade máxima de ${MAX_ITENS_POR_PROTOCOLO} propostas no protocolo.`,
};
const PROTOCOLO_ERROS_MENSAGENS = {
  LIMITE_MAX_PROTOCOLO: `Limite máximo de contratos por protocolo é ${MAX_ITENS_POR_PROTOCOLO}`,
  ERRO_PROTOCOLO_MASSA: 'Ocorreu um erro ao realizar o protocolo em massa, tente novamente.',
};

export {
  ERROS_PROTOCOLO_MASSA,
  MAX_ITENS_POR_PROTOCOLO,
  PROTOCOLO_ERROS_MENSAGENS,
};
